/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJob } from '../models/CompanyJob';
import type { Composite } from '../models/Composite';
import type { CompositeDataCutAdjustmentDetails } from '../models/CompositeDataCutAdjustmentDetails';
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { Paymarket } from '../models/Paymarket';
import type { SurveyBlob } from '../models/SurveyBlob';
import type { SurveyData } from '../models/SurveyData';
import type { SurveyDataCut } from '../models/SurveyDataCut';
import type { SurveyDataCutBlob } from '../models/SurveyDataCutBlob';
import type { SurveyDataCutPaymarketMappingDirection } from '../models/SurveyDataCutPaymarketMappingDirection';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';
import type { SurveyJobDefinitionBlob } from '../models/SurveyJobDefinitionBlob';
import type { SurveyJobMappingReplacementAutoMatchingType } from '../models/SurveyJobMappingReplacementAutoMatchingType';
import type { SurveyJobSort } from '../models/SurveyJobSort';
import type { SurveyReplacement } from '../models/SurveyReplacement';
import type { SurveyReplacementApplyPolicyOnScopeRequest } from '../models/SurveyReplacementApplyPolicyOnScopeRequest';
import type { SurveyReplacementCompleteSetupContext } from '../models/SurveyReplacementCompleteSetupContext';
import type { SurveyReplacementCompositeDataCut } from '../models/SurveyReplacementCompositeDataCut';
import type { SurveyReplacementCompositeDataCutCreateRequest } from '../models/SurveyReplacementCompositeDataCutCreateRequest';
import type { SurveyReplacementCompositeDataCutRowStatus } from '../models/SurveyReplacementCompositeDataCutRowStatus';
import type { SurveyReplacementCompositeDataCutRowStatusFilter } from '../models/SurveyReplacementCompositeDataCutRowStatusFilter';
import type { SurveyReplacementCompositeDataCutSelectionSourceFilter } from '../models/SurveyReplacementCompositeDataCutSelectionSourceFilter';
import type { SurveyReplacementCompositeDataCutSort } from '../models/SurveyReplacementCompositeDataCutSort';
import type { SurveyReplacementCompositeDataCutStatistic } from '../models/SurveyReplacementCompositeDataCutStatistic';
import type { SurveyReplacementCompositeLookingFor } from '../models/SurveyReplacementCompositeLookingFor';
import type { SurveyReplacementCutStrategyRunHistoryResponse } from '../models/SurveyReplacementCutStrategyRunHistoryResponse';
import type { SurveyReplacementCutStrategyRunRequest } from '../models/SurveyReplacementCutStrategyRunRequest';
import type { SurveyReplacementCutStrategyRunResponse } from '../models/SurveyReplacementCutStrategyRunResponse';
import type { SurveyReplacementCutStrategyRunStatusResponse } from '../models/SurveyReplacementCutStrategyRunStatusResponse';
import type { SurveyReplacementDataCutMappingStatistic } from '../models/SurveyReplacementDataCutMappingStatistic';
import type { SurveyReplacementDataCutName } from '../models/SurveyReplacementDataCutName';
import type { SurveyReplacementDataCutPaymarketMapping } from '../models/SurveyReplacementDataCutPaymarketMapping';
import type { SurveyReplacementDataCutPaymarketMappingInfoRow } from '../models/SurveyReplacementDataCutPaymarketMappingInfoRow';
import type { SurveyReplacementDataCutRowStatus } from '../models/SurveyReplacementDataCutRowStatus';
import type { SurveyReplacementDataSelectionType } from '../models/SurveyReplacementDataSelectionType';
import type { SurveyReplacementDecision } from '../models/SurveyReplacementDecision';
import type { SurveyReplacementJobMappingScope } from '../models/SurveyReplacementJobMappingScope';
import type { SurveyReplacementJobMappingStatistic } from '../models/SurveyReplacementJobMappingStatistic';
import type { SurveyReplacementMappedFilter } from '../models/SurveyReplacementMappedFilter';
import type { SurveyReplacementReviewDiffRow } from '../models/SurveyReplacementReviewDiffRow';
import type { SurveyReplacementReviewDiffRowStatusFilter } from '../models/SurveyReplacementReviewDiffRowStatusFilter';
import type { SurveyReplacementReviewDiffStatistic } from '../models/SurveyReplacementReviewDiffStatistic';
import type { SurveyReplacementRowStatus } from '../models/SurveyReplacementRowStatus';
import type { SurveyReplacementSummary } from '../models/SurveyReplacementSummary';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyReplacementService {

    /**
     * Get Survey Replacement
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacement({
        surveyId,
        planId,
    }: {
        /**
         * Survey Id
         */
        surveyId: string,
        /**
         * Plan Id
         */
        planId: number,
    }): CancelablePromise<{
        surveyReplacement: (SurveyReplacement | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement',
            query: {
                'surveyId': surveyId,
                'planId': planId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Replacement
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacement({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Apply New Survey
     * @returns any Success
     * @throws ApiError
     */
    public static applySurvey({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            /**
             * Deprecated single-source field. Normalized server-side into surveyIds. Either surveyId or surveyIds is required.
             */
            surveyId?: string;
            /**
             * Source surveys to replace with the target survey. Takes precedence over surveyId.
             */
            surveyIds?: Array<string>;
            targetSurveyId: string;
            stateUuid?: string;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/applySurvey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Get list of jobs for survey replacement
     * @returns any Success
     * @throws ApiError
     */
    public static searchSurveyJobs({
        requestBody,
    }: {
        requestBody: {
            /**
             * Survey ID
             */
            surveyId: string;
            /**
             * Page number
             */
            offset?: number;
            /**
             * Max items per page
             */
            limit?: number;
            sort?: SurveyJobSort;
            search?: string;
            careerLevel?: Array<string>;
            globalLevel?: Array<string>;
            jobSubFamily?: Array<string>;
            jobFamily?: Array<string>;
            jobFocus?: Array<string>;
            jobType?: string | null;
            module?: Array<string>;
            purchasedOnly?: boolean;
            companyJobId?: number;
            recommendationMode?: 'semantic_ordering' | 'similarity_scores';
        },
    }): CancelablePromise<{
        rows: Array<DHSurveyJobDefinition>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/searchSurveyJobs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Publish Survey Replacement
     * @returns any Success
     * @throws ApiError
     */
    public static publishSurveyReplacement({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/publish',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Get Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementJobMapping({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            ids?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobCategory?: Array<number>;
            jobLevel?: Array<number>;
            statuses?: Array<SurveyReplacementDecision>;
            rowStatus?: Array<SurveyReplacementRowStatus>;
            autoMatchingType?: SurveyJobMappingReplacementAutoMatchingType;
            mapped?: SurveyReplacementMappedFilter;
            scope?: SurveyReplacementJobMappingScope;
            search?: string;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
        },
    }): CancelablePromise<{
        rows: Array<CompanyJob>;
        /**
         * Company jobs matching the filter, ignoring limit/offset — what the pages are counted over
         */
        count: number;
        jobDefinitionBlobs?: Record<string, (SurveyJobDefinitionBlob | Record<string, any>)>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/jobMapping',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Symmary
     * @returns SurveyReplacementSummary Success
     * @throws ApiError
     */
    public static getSurveyReplacementSummary({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<SurveyReplacementSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/summary',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Summary Report Url
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementSummaryReportUrl({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/summaryReportUrl',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Review Diff
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementReviewDiff({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            paymarketIds?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
            rowStatus?: SurveyReplacementReviewDiffRowStatusFilter;
            compositeIds?: Array<number>;
            sort?: SurveyReplacementCompositeDataCutSort;
            limit?: number;
            offset?: number;
        },
    }): CancelablePromise<{
        rows: Array<SurveyReplacementReviewDiffRow>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/reviewDiff/list',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Review Diff Statistic
     * @returns SurveyReplacementReviewDiffStatistic Success
     * @throws ApiError
     */
    public static getSurveyReplacementReviewDiffStatistic({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            paymarketIds?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<SurveyReplacementReviewDiffStatistic> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/reviewDiff/statistic',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Keep the prior edition's mapping, cut and value on dropped Step 6 rows
     * Marks Step 6 rows as "use previous", so the prior edition's cut and value stay attached to the company job through publish instead of being dropped.
     * Either name the rows explicitly, or send allDropped with the table's filters to apply to every eligible row in that scope. A row is eligible while it is still dropped and still holds prior-edition cuts to keep; the count matching that scope is usePreviousEligible on reviewDiff/statistic.
     * usePrevious false clears the flag again.
     * @returns any Success
     * @throws ApiError
     */
    public static setSurveyReplacementUsePrevious({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            /**
             * false clears the flag on the named rows.
             */
            usePrevious?: boolean;
            /**
             * The rows to act on, keyed the way the diff identifies them. Mutually exclusive with allDropped.
             */
            rows?: Array<{
                compositeId: number;
                surveyReplacementJobMappingId: number;
            }>;
            /**
             * Apply to every eligible row in the filtered scope — the header action. The filters below are the same ones reviewDiff/list takes, so the button's count and its effect cover the same population.
             */
            allDropped?: boolean;
            paymarketIds?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<{
        affected: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/reviewDiff/usePrevious',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Complete Setup Context
     * @returns SurveyReplacementCompleteSetupContext Success
     * @throws ApiError
     */
    public static getSurveyReplacementCompleteSetupContext({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<SurveyReplacementCompleteSetupContext> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/completeSetupContext',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Actualize Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static actualizeSurveyReplacementJobMapping({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/jobMapping/actualize',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Job Mapping Statistic
     * @returns SurveyReplacementJobMappingStatistic Success
     * @throws ApiError
     */
    public static getSurveyReplacementJobMappingStatistic({
        replacementId,
        scope,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Which jobs the tiles count. Defaults to the whole profile.
         */
        scope?: SurveyReplacementJobMappingScope,
    }): CancelablePromise<SurveyReplacementJobMappingStatistic> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/jobMapping/statistic',
            path: {
                'replacementId': replacementId,
            },
            query: {
                'scope': scope,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyReplacementJobMapping({
        replacementId,
        jobMappingId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Job Mapping Id
         */
        jobMappingId: number,
        requestBody: {
            targetSurveyJobDefinitionId?: string | null;
            adjustment?: number | null;
            status?: SurveyJobCompanyJobMappingStatus;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveyReplacement/{replacementId}/jobMapping/{jobMappingId}',
            path: {
                'replacementId': replacementId,
                'jobMappingId': jobMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Delete Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacementJobMapping({
        replacementId,
        jobMappingId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Job Mapping Id
         */
        jobMappingId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/jobMapping/{jobMappingId}',
            path: {
                'replacementId': replacementId,
                'jobMappingId': jobMappingId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Survey Replacement Job Mapping Next Step
     * @returns any Success
     * @throws ApiError
     */
    public static surveyReplacementJobMappingNext({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            stateUuid: string;
            /**
             * When true, mappings still pending a decision are marked as skipped instead of blocking the step transition with a conflict.
             *
             */
            acknowledgePending?: boolean;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/jobMapping/next',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Survey Replacement Data Cut Paymarket Mapping Next Step
     * @returns any Success
     * @throws ApiError
     */
    public static surveyReplacementDataCutPaymarketMappingNext({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            stateUuid: string;
            /**
             * When true, cut mappings still pending a decision are marked as skipped instead of blocking the step transition with a conflict.
             *
             */
            acknowledgePending?: boolean;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/next',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Actualize Survey Replacement DataCut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static actualizeSurveyReplacementDataCutPaymarketMapping({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/actualize',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement DataCut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            ids?: Array<number>;
            /**
             * Filter to a single paymarket. Mutually exclusive with paymarketIds — supplying both returns a 400.
             */
            paymarketId?: number;
            /**
             * Filter to multiple paymarkets. Mutually exclusive with paymarketId — supplying both returns a 400.
             */
            paymarketIds?: Array<number>;
            /**
             * Filter to rows whose previous-edition cut is one of these. Used to find where else the same previous cut is mapped.
             */
            sourceSurveyDataCutIds?: Array<string>;
            /**
             * Filter to rows whose paymarket is priced in this currency. A target cut exists for one currency, so rows on any other currency cannot take that cut.
             *
             */
            currencyId?: number;
            statuses?: Array<SurveyReplacementDecision>;
            rowStatus?: Array<SurveyReplacementDataCutRowStatus>;
            mapped?: SurveyReplacementMappedFilter;
            search?: string;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
        },
    }): CancelablePromise<{
        rows: Array<SurveyReplacementDataCutPaymarketMappingInfoRow>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/list',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement DataCut Mapping Statistic
     * @returns SurveyReplacementDataCutMappingStatistic Success
     * @throws ApiError
     */
    public static getSurveyReplacementDataCutMappingStatistic({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<SurveyReplacementDataCutMappingStatistic> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/statistic',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create Survey Replacement DataCut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static createSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            /**
             * Add the cut to a single paymarket. Mutually exclusive with paymarketIds — supplying both, or neither, returns a 400.
             */
            paymarketId?: number;
            /**
             * Add the cut to every listed paymarket in one transaction. Mutually exclusive with paymarketId.
             */
            paymarketIds?: Array<number>;
            targetSurveyDataCutId: string;
        },
    }): CancelablePromise<{
        rows: Array<SurveyReplacementDataCutPaymarketMapping>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/create',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Apply one target survey data cut to several Replacement Data Cut Paymarket Mappings
     * Applies the same target cut to every listed mapping in one transaction. Used by the cross-paymarket step on wizard step 3, where the previous cut is mapped in more than one paymarket and the user chooses which of them to carry the change into.
     *
     * @returns any Success
     * @throws ApiError
     */
    public static applyTargetSurveyDataCutToMappings({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            /**
             * Replacement Data Cut Paymarket Mapping ids to update. Every id must belong to this replacement.
             */
            ids: Array<number>;
            targetSurveyDataCutId: string | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/applyTargetSurveyDataCut',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Get paymarkets for replaced cuts
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementDataCutPaymarkets({
        replacementId,
        mapped,
        currencyId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Return only paymarkets that have replaced cuts in a target survey
         */
        mapped?: boolean,
        /**
         * Return only paymarkets priced in this currency. A target cut only exists for one currency, so paymarkets on any other currency cannot take that cut and must not be offered.
         *
         */
        currencyId?: number,
    }): CancelablePromise<{
        rows: Array<Paymarket>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/paymarket',
            path: {
                'replacementId': replacementId,
            },
            query: {
                'mapped': mapped,
                'currencyId': currencyId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get paymarkets for replaced cuts
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementDataCutMappingsSearch({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            /**
             * Paymarket ID
             */
            paymarketId: number;
            /**
             * Page number
             */
            offset?: number;
            /**
             * Max items per page
             */
            limit?: number;
        },
    }): CancelablePromise<{
        rows: Array<SurveyReplacementDataCutPaymarketMapping>;
        surveyDataCuts?: Record<string, (SurveyDataCut | Record<string, any>)>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/search',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Target Survey Data Cut for Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static updateTargetSurveyDataCut({
        replacementId,
        dataCutPaymarketMappingId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Data Cutp Paymarket Mapping Id
         */
        dataCutPaymarketMappingId: number,
        requestBody: {
            targetSurveyDataCutId: string | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Update Survey Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        dataCutPaymarketMappingId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Data Cutp Paymarket Mapping Id
         */
        dataCutPaymarketMappingId: number,
        requestBody: {
            adjustment?: number;
            weight?: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Delete Survey Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        dataCutPaymarketMappingId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Data Cutp Paymarket Mapping Id
         */
        dataCutPaymarketMappingId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Change the order of a Survey Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static changeOrderReplacementDataCutPaymarketMapping({
        replacementId,
        dataCutPaymarketMappingId,
        requestBody,
    }: {
        /**
         * The ID of the Survey Replacement.
         */
        replacementId: number,
        /**
         * The ID of the Survey Replacement Data Cut Paymarket Mapping to reorder.
         */
        dataCutPaymarketMappingId: number,
        requestBody: {
            direction: SurveyDataCutPaymarketMappingDirection;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}/position',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Enable Survey Replacement Composite Data Cut
     * @returns SurveyReplacementCompositeDataCut Success
     * @throws ApiError
     */
    public static createSurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: SurveyReplacementCompositeDataCutCreateRequest,
    }): CancelablePromise<Array<SurveyReplacementCompositeDataCut>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Disable Survey Replacement Composite Data Cut
     * @returns any Record deleted successfully. No content returned.
     * @throws ApiError
     */
    public static removeSurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            compositeId: number;
            targetSurveyDataId: string;
        },
    }): CancelablePromise<{
        ids?: Array<number>;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/compositeDataCut',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement CompositeDataCut
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            paymarketId?: number;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
            rowStatus?: SurveyReplacementCompositeDataCutRowStatusFilter;
            selectionSource?: SurveyReplacementCompositeDataCutSelectionSourceFilter;
            compositeIds?: Array<number>;
            sort?: SurveyReplacementCompositeDataCutSort;
            limit?: number;
            offset?: number;
        },
    }): CancelablePromise<{
        rows: Array<(Composite & {
            rowStatus: SurveyReplacementCompositeDataCutRowStatus;
            lookingFor?: SurveyReplacementCompositeLookingFor;
        })>;
        surveyReplacementDataCutPaymarketMappings: Array<SurveyReplacementDataCutPaymarketMapping>;
        targetSurveyBlob: (SurveyBlob | Record<string, any> | null);
        surveyJobDefinitionBlobs: Record<string, (SurveyJobDefinitionBlob | Record<string, any>)>;
        surveyDataCutBlobs: Record<string, (SurveyDataCutBlob | Record<string, any>)>;
        surveyDataBlobs: Array<SurveyData>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/list',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement CompositeDataCut Statistic
     * @returns SurveyReplacementCompositeDataCutStatistic Success
     * @throws ApiError
     */
    public static getSurveyReplacementCompositeDataCutStatistic({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            paymarketId?: number;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<SurveyReplacementCompositeDataCutStatistic> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/statistic',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Actualize Survey Replacement CompositeDataCut
     * @returns any Success
     * @throws ApiError
     */
    public static actualizeSurveyReplacementCompositeDataCut({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<{
        surveyReplacement: (SurveyReplacement | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/actualize',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Survey Replacement Composite Data Cut Next Step
     * Records the move off cut review onto review & confirm. Unlike the job-mapping and cut-mapping transitions there is nothing to validate here — cut review has no blocking decision — so this only persists the step, which is what lets a reload or a later re-entry land on review & confirm instead of falling back to cut strategy.
     *
     * @returns any Success
     * @throws ApiError
     */
    public static surveyReplacementCompositeDataCutNext({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            stateUuid: string;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/next',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Apply Policy on Survey Replacement CompositeDataCut
     * @returns any Success
     * @throws ApiError
     */
    public static applyCutSelectionPolicySurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            cutSelectionPolicyType: SurveyReplacementDataSelectionType;
            pricingPolicyId?: number | null;
            paymarketId: number;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/applyCutSelectionPolicy',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Run cut strategies across paymarkets in a single run (Step 4)
     * @returns SurveyReplacementCutStrategyRunResponse Success
     * @throws ApiError
     */
    public static runSurveyReplacementCutStrategy({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: SurveyReplacementCutStrategyRunRequest,
    }): CancelablePromise<SurveyReplacementCutStrategyRunResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/cutStrategyRun',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Run a cut selection policy across the paymarkets currently in scope (Step 5)
     * @returns SurveyReplacementCutStrategyRunResponse Success
     * @throws ApiError
     */
    public static runSurveyReplacementApplyPolicyOnScope({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: SurveyReplacementApplyPolicyOnScopeRequest,
    }): CancelablePromise<SurveyReplacementCutStrategyRunResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/applyPolicyRun',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Cut strategy run history for a replacement
     * @returns SurveyReplacementCutStrategyRunHistoryResponse Success
     * @throws ApiError
     */
    public static getSurveyReplacementCutStrategyRunHistory({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<SurveyReplacementCutStrategyRunHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/cutStrategyRun/history',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Cut strategy run progress (poll)
     * @returns SurveyReplacementCutStrategyRunStatusResponse Success
     * @throws ApiError
     */
    public static getSurveyReplacementCutStrategyRunStatus({
        replacementId,
        runId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Cut Strategy Run Id
         */
        runId: number,
    }): CancelablePromise<SurveyReplacementCutStrategyRunStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/cutStrategyRun/{runId}/status',
            path: {
                'replacementId': replacementId,
                'runId': runId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Survey Replacement Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyReplacementCompositeDataCut({
        replacementId,
        compositeDataCutId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Composite Data Cut Id
         */
        compositeDataCutId: number,
        requestBody: {
            adjustment?: number;
            weight?: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/{compositeDataCutId}',
            path: {
                'replacementId': replacementId,
                'compositeDataCutId': compositeDataCutId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * get adjustment and weight details
     * @returns CompositeDataCutAdjustmentDetails Success
     * @throws ApiError
     */
    public static getSurveyReplacementCompositeDataCutAdjustmentDetails({
        replacementId,
        compositeDataCutId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Composite Data Cut Id
         */
        compositeDataCutId: number,
    }): CancelablePromise<CompositeDataCutAdjustmentDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/{compositeDataCutId}/adjustment',
            path: {
                'replacementId': replacementId,
                'compositeDataCutId': compositeDataCutId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Upsert Survey Replacement Data Cut Name
     * @returns SurveyReplacementDataCutName Success
     * @throws ApiError
     */
    public static upsertSurveyReplacementDataCutName({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            targetSurveyDataCutId: string;
            name: string;
        },
    }): CancelablePromise<SurveyReplacementDataCutName> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/surveyDataCutName',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Replacement Data Cut Name
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacementDataCutName({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            targetSurveyDataCutId: string;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/surveyDataCutName',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Survey Replacement Summary Report
     * @returns string Success
     * @throws ApiError
     */
    public static generateSurveyReplacementSummaryReport({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/report/summary',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Survey Replacement Dropped Jobs Report
     * @returns string Success
     * @throws ApiError
     */
    public static exportSurveyReplacementDroppedJobsReport({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/report/droppedJobs',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

}
